// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"0e094e42","3091":"0e094e42","5472":"0e094e42","8153":"0e094e42","9002":"0e094e42"}[chunkId] + ".chunk.css";
};